import { Account } from './Types';
import { INITIAL_ACCOUNT_STATE } from './Constants';
import { AuthState } from '../auth/auth.types';
import { AdminState } from '../admin/admin.types';

export const pickAccount = (authState: AuthState, adminState: AdminState): Account =>
  adminState.impersonation && adminState.impersonation.account && adminState.impersonation.authToken ?
    adminState.impersonation.account :
    authState.account ?
      authState.account :
      INITIAL_ACCOUNT_STATE;


// WEBPACK FOOTER //
// ./src/account/Util.tsx